module.exports = "<div class=\"d-inline-flex justify-content-around p-3\"\n     style=\"overflow-x: auto;background: #fff;border-radius: 4px;\">\n\n\n</div>\n"